import React, { useState } from 'react';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import Checkbox from '@visa/vds/checkbox';
import CheckboxSet from '@visa/vds/checkbox-set';
import CheckboxList from '@visa/vds/checkbox-list';
import CheckboxListItem from '@visa/vds/checkbox-list-item';
import Tr from '@visa/vds/tr';
import Td from '@visa/vds/td';
import MCSPagedTable from '../../../../components/MCSPagedTable';
import { DateHelper } from "../../../../_helpers/DateHelper";
import { useEffect } from 'react';
import col from '@visa/vds/col';

const BillingReviewTable = (props) => {
    const tableData = props.tableData;
    const colHeadersTemplate = [
        { displayName: "Business Name", name: "OrganizationName" }, // 0
        { displayName: "Country", name: "CountryName" },
        { displayName: "Region", name: "RegionName" },
        { displayName: "BID", name: "BID" },
        { displayName: "Product Name", name: "ProductName" },
        { displayName: "Subscription Name", name: "SubscriptionName" },
        { displayName: "Subscription Start Date", name: "StartDate" },
        //NEW added two columns here
        { displayName: "Custom Description", name: "CustomDescription" } // 7

    ];    
    const feeWaiverColumns = [{ displayName: "Fee Waiver or Fee Discount Description", name: "feeWaiverDescription"}, { displayName: "Pre-Rated Amount", name:"preRatedAmount"}];
    const [showCustomDesc, setShowCustomDesc] = useState(false);
    const [colHeaders, setColHeaders] = useState(colHeadersTemplate);

    function generateColHeaders(showCustomDesc) {
        let array = [...colHeadersTemplate];
        // dont show last column if state not set
        if (!showCustomDesc){
            array.splice(-1, 1);
        } 
        if(props.showFeeWaiver){
            array.splice(7, 0, feeWaiverColumns[0], feeWaiverColumns[1]); 
        }
        return array;
    };

    const handleChangeShowCustomDesc = (e) => {
        // setColHeaders(generateColHeaders(updated));
        setShowCustomDesc(!showCustomDesc);
    };

    const showRow = (row) => {
        if(row.productSubscriptionInfo.feeWaiverId){
            return true;
        }
        return false;
    }

    useEffect(() => {
        const _colHeaders = generateColHeaders(showCustomDesc);
        setColHeaders(_colHeaders);
    }, [showCustomDesc, props.showFeeWaiver])

    if (!tableData)
        return <></>;

    return (
        <>
            <Row>
                <Col textAlign="right">
                    <CheckboxSet>
                        <CheckboxList>
                            <CheckboxListItem>
                                <Checkbox
                                    checked={showCustomDesc}
                                    name="checkbox-show-custom-desc"
                                    label="Show Custom Description"
                                    value="show"
                                    onChange={handleChangeShowCustomDesc}
                                />
                            </CheckboxListItem>
                        </CheckboxList>
                    </CheckboxSet>
                </Col>
                <MCSPagedTable
                    colHeaders={colHeaders}
                    usePagination={true}
                    selectedPage={props.selectedPage}
                    setSelectedPage={props.handlePageChange}
                    totalPages={props.totalPages}
                    pageSize={props.pageSize}
                    totalCount={props.totalCount}
                    tableData={
                        tableData.map((row, key) => (
                            <Tr key={key}>
                                <Td>{row.organizationInfo.organizationName}</Td>
                                <Td>{row.organizationInfo.countryName} ({row.organizationInfo.countryCode})</Td>
                                <Td>{row.organizationInfo.regionName != "" ? row.organizationInfo.regionName : "-"}</Td>
                                <Td>{row.organizationInfo.bid}</Td>
                                <Td>{row.productSubscriptionInfo.productName}</Td>
                                <Td>{row.productSubscriptionInfo.subscriptionName}</Td>
                                <Td>{DateHelper.ToFormattedDate(row.productSubscriptionInfo.startDate)}</Td>
                                {/* NEW added two new column values */}
                                {showRow(row) && props.showFeeWaiver && <Td>{row.productSubscriptionInfo.feeWaiverDescription}</Td>}
                                {showRow(row) && props.showFeeWaiver && <Td>{`${row.preRatedAmount} USD`}</Td>}
                                {!showRow(row) && props.showFeeWaiver && <Td></Td>}
                                {!showRow(row) && props.showFeeWaiver && <Td></Td>}
                                {showCustomDesc &&
                                    <Td style={{ minWidth: "370px" }}>
                                        {row.customDescription}
                                    </Td>
                                }
                            </Tr>
                        ))
                    }
                />
            </Row>
        </>
    );
}

export default BillingReviewTable;

